import { PartnerTypeFieldsPermission } from "./PartnerTypeFieldsPermission";
import { PartnerTypeFeaturesPermission } from "./PartnerTypeFeaturesPermission";
export class PartnerType {
    Code: string | null;
    Name: string | null;
    PartnerTypeFieldsPermissions:PartnerTypeFieldsPermission[]
    PartnerTypeFeaturesPermissions:PartnerTypeFeaturesPermission[]
}